import { render, staticRenderFns } from "./WatchlistTeaser.vue?vue&type=template&id=4cd5c087&scoped=true&"
import script from "./WatchlistTeaser.vue?vue&type=script&lang=js&"
export * from "./WatchlistTeaser.vue?vue&type=script&lang=js&"
import style0 from "./WatchlistTeaser.vue?vue&type=style&index=0&id=4cd5c087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5c087",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd5c087')) {
      api.createRecord('4cd5c087', component.options)
    } else {
      api.reload('4cd5c087', component.options)
    }
    module.hot.accept("./WatchlistTeaser.vue?vue&type=template&id=4cd5c087&scoped=true&", function () {
      api.rerender('4cd5c087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/watchlist/WatchlistTeaser.vue"
export default component.exports